const getters = {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    hasSideEffectLoading : state => state.app.hasSideEffectLoading,
    token: state => state.user.token,
    name: state => state.user.name,
    userId: state => state.user.userId,
    role: state => state.user.role,
    roleId: state => state.user.roleId,
    branches: state => state.user.branches,
    menus: state => state.user.menus,
    gate: state => state.user.gate,
    branch: state => state.user.branch,
    companyName: state => state.user.companyName,
    cars: state => state.user.cars,
    miniCars: state => state.user.miniCars,
    wtUnits: state => state.user.wtUnits,
    addRouters: state => state.permission.addRouters,
    routers: state => state.permission.routers,
    gates: state => state.user.gates,
    menus: state => state.user.menus,
    roles: state => state.user.roles,
    gateBranches: state => state.user.gateBranches,
}
export default getters
